import { lazy } from 'react';

const PublicJoinPage = lazy(() => import('src/pages/public/join'));

/**
 * An organization's public volunteer invite link. Like the survey route: no AuthGuard, because
 * whoever scanned the QR code has no account yet, and no GuestGuard either -- that would bounce
 * a signed-in manager to the dashboard when they open their own link to check it.
 */
export const publicJoinRoutes = [
  {
    path: 'join/:token',
    element: <PublicJoinPage />,
  },
];
